import { AUTH_TOKEN_LOCAL_STORAGE_KEY } from './constants';

export const getAuthTokenFromLocalStorage = (key?: string) => {
  return localStorage.getItem(key || AUTH_TOKEN_LOCAL_STORAGE_KEY);
};
